import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { createTheme, Grid } from "@mui/material";
import AddMail from "./project-add-mail/AddMail";
import ExternalInfoNavbar from "../../../molecules/nav-bars/project-external-info";
import { ThemeProvider } from "@emotion/react";
import ManageProjectNotification from "./project-add-mail/ManageProjectNotification";
interface ViewAgendaProps {
  open: boolean;
  onClose: () => void;
  projectId: string | null;
  isProjectOpen: boolean;
}
const ExternalInfo: React.FC<ViewAgendaProps> = ({ open, onClose, projectId }) => {

    const [selectedTab, setSelectedTab] = useState(0);
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
    };
    const handleModalClose = () => {
        onClose()
        setSelectedTab(0)
    }
    const theme = createTheme({
        typography: {
          fontFamily: ['Montserrat'].join(','),
          fontSize: 10,
          fontWeightRegular: '500',
        },
        palette: {
          primary: {
            main: '#EC9324',
          },
        },
    });

  return (
    <ThemeProvider theme={theme}>
    <Modal
        open={open}
        onClose={handleModalClose}
        sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mt: "50px",
        }}
    >
        <Box
        sx={{
            position: "relative",
            width: 700,
            maxHeight: 600,
            minHeight: 400,
            bgcolor: "white",
            borderRadius: 2,
        }}
        >
        {/* Header */}
        <Stack
            direction="row"
            justifyContent="space-between"
            px={2.5}
            py={1.5}
        >
            <Typography fontSize={16} fontWeight={600} sx={{ opacity: 0.8 }}>
            External Info
            </Typography>
            <CloseIcon
            sx={{
                fontSize: 18,
                color: "#434343",
                opacity: 0.75,
                cursor: "pointer",
            }}
            onClick={handleModalClose}
            />
        </Stack>
        <hr style={{ opacity: "0.75" }} />

        {/* Navbar */}
        <Stack>
            <ExternalInfoNavbar
            selectedTab={selectedTab}
            handleTabChange={handleTabChange}
            />
        </Stack>

        {/* Tab content */}
        <Stack justifyContent="center" alignItems="center" px={2.5}>
            {selectedTab === 0 && <AddMail projectId={projectId} onClose={handleModalClose} />}
            {selectedTab === 1 && <ManageProjectNotification projectId={projectId} onClose={handleModalClose}/>}
        </Stack>
        </Box>
    </Modal>
    </ThemeProvider>
  );
};

export default ExternalInfo;
